export default "__VITE_ASSET__43ba25d1__"